const PROVIDERS = {
  CUSTOM: 'custom',
  GOODSPEED: 'goodspeed',
};

export default PROVIDERS;
